export default "__VITE_ASSET__DpsW0KYL__"